export default __webpack_public_path__ + "static/media/world.1349ad61.svg";